const supportedCountries = {
  UK: "UK",
} as const;

export default supportedCountries;
